<div class="container-fluid py-3">

  <!-- Header -->
  <div class="row mb-4">
    <div class="col d-flex align-items-center">
      <div>
        <h6 class="mb-0 fw-bold">Casas con crédito</h6>
      </div>
    </div>
  </div>

  <div class="row">

    <div class="col-6 col-md-4 col-xl-3 mb-3">
      <div class="bg-white rounded-3 shadow-sm p-3 h-100">
        <div class="text-secondary movementsCreditsPage__cardLabel">
          Crédito total
        </div>
        @if(loading) {
          <div class="placeholder-glow">
            <span class="placeholder col-8 rounded movementsCreditsPage__cardPlaceholder"></span>
          </div>
        } @else {
          <div class="fw-bold movementsCreditsPage__cardValue">
            {{ totalCreditBalance | currency }}
          </div>
        }
      </div>
    </div>

    <div class="col-6 col-md-4 col-xl-3 mb-3">
      <div class="bg-white rounded-3 shadow-sm p-3 h-100">
        <div class="text-secondary movementsCreditsPage__cardLabel">
          Casas con crédito
        </div>
        @if(loading) {
          <div class="placeholder-glow">
            <span class="placeholder col-6 rounded movementsCreditsPage__cardPlaceholder"></span>
          </div>
        } @else {
          <div class="fw-bold movementsCreditsPage__cardValue">
            {{ housesWithCredit }}
          </div>
        }
      </div>
    </div>

    <div class="col-12">
      <p-table
        [value]="houses"
        [loading]="loading"
        [rowHover]="true"
        [paginator]="true"
        [rows]="50"
        [rowsPerPageOptions]="[50, 100, 200, 500, { showAll: 'Todos' }]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">
        <ng-template pTemplate="header">
          <tr>
            <th>Calle / Edificio</th>
            <th>Casa</th>
            <th>Residente</th>
            <th class="text-end">Crédito</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-house>

          <!-- Fila-enlace: el clic en cualquier celda abre los pagos de la
               vivienda. Se conserva el rol nativo de fila (no se pisa con
               role="button") para no romper la navegacion por tabla del lector
               de pantalla; la fila se anuncia con aria-label y se activa con
               Enter o Espacio. -->
          <tr
            (click)="goToHouseFlatPayments(house)"
            (keydown.enter)="goToHouseFlatPayments(house, $event)"
            (keydown.space)="goToHouseFlatPayments(house, $event)"
            class="p-selectable-row movementsCreditsPage__row"
            tabindex="0"
            [attr.aria-label]="'Ver los pagos de la vivienda ' + house.number + ' de ' + house.streetBuildingName">

            <td>{{ house.streetBuildingName }}</td>
            <td>{{ house.number }}</td>
            <td class="text-secondary">{{ house.fullName }}</td>
            <td class="text-end fw-bold">{{ house.creditBalance | currency }}</td>

          </tr>

        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center text-muted py-4">
              <i class="material-icons d-block mb-1 movementsCreditsPage__emptyIcon">savings</i>
              <small>Sin casas con crédito</small>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</div>
